import { useCompanyCapabilities } from "../../hooks/useCompanyCapabilities";
import { CardComp } from "..";

export default function InvestorPortalCapabilityGate({ children }) {
  const caps = useCompanyCapabilities();
  const hasAny =
    caps.investorPortal ||
    caps.investment ||
    caps.marketplace ||
    caps.realEstate ||
    caps.cooperativeRequest;

  if (!hasAny) {
    return (
      <CardComp cardClassName="border-0 shadow-sm rounded-4 my-4">
        <div className="text-center py-5 px-3">
          <h5 className="fw-bold mb-2">Investor features unavailable</h5>
          <p className="text-muted mb-0">
            This cooperative has not enabled investment, marketplace, or related services. Contact
            the cooperative office for assistance.
          </p>
        </div>
      </CardComp>
    );
  }

  return children;
}
